export default __webpack_public_path__ + "static/media/addBlue.348195f8.svg";